var __jsx = React.createElement;
import React from "react";
import useHelpers from "@hooks/useHelpers";
import useIsMobile from "@hooks/useIsMobile";
import { useCMS } from "@hooks/useCMS";
import { URL_SELL_TRADE_FORM_v2 } from "@/pages/sell-trade-v2/sell-trade/constants";
import { trackEvents } from "@/common/events/events";
import { getPlatformInfo } from "@/utils/GlobalJavascriptFunction";
import useCheckABFlag from "@hooks/useCheckABFlag";
var SellCarHero = function SellCarHero(_ref) {
  var data = _ref.data;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var isMobile = useIsMobile();
  var _useCMS = useCMS(),
    getCMSImageUrl = _useCMS.imageUrl;
  var isABTestEnabled = useCheckABFlag("AB_SELL_MY_CAR_V3");
  var handleCTAClick = function handleCTAClick() {
    trackEvents("sell_car_form_landing", {
      platform: getPlatformInfo(),
      "referral_location": "main_banner",
      version: isABTestEnabled && "3"
    });
    navigateTo(URL_SELL_TRADE_FORM_v2);
  };

  // Use mobile image if available and on mobile, otherwise use desktop image
  var imagePath = isMobile && data.image_mobile ? data.image_mobile : data.image;
  return /*#__PURE__*/React.createElement("div", {
    id: "sell-car-hero-section",
    className: "relative w-full p-4 md:p-4 mt-4"
  }, /*#__PURE__*/React.createElement("img", {
    id: "sell-car-hero-background-image",
    src: getCMSImageUrl(imagePath),
    alt: "Hero Background",
    className: "w-full max-h-[800px] object-cover rounded-xl md:rounded-3xl",
    loading: data.image_loading_behavior === "eager" ? "eager" : "lazy"
  }), /*#__PURE__*/React.createElement("div", {
    id: "sell-car-hero-content-overlay",
    className: "absolute inset-0 flex items-start md:items-center justify-center md:justify-start pt-[45px] md:pt-0 px-4 md:px-8 z-10"
  }, /*#__PURE__*/React.createElement("div", {
    id: "sell-car-hero-content-wrapper",
    className: " w-full mx-auto flex items-start md:items-center justify-center md:justify-start"
  }, /*#__PURE__*/React.createElement("div", {
    id: "sell-car-hero-content-box",
    className: "md:mx-32 flex flex-col items-center md:items-start text-center md:text-start"
  }, /*#__PURE__*/React.createElement("h1", {
    id: "sell-car-hero-title",
    className: "text-primary-new text-[26px] md:text-5xl font-bold mb-4 md:mb-6 whitespace-pre-line max-w-[600px]"
  }, function () {
    var firstDotIndex = data.label1.indexOf(".");
    if (firstDotIndex === -1) {
      return data.label1;
    }
    var firstLine = data.label1.substring(0, firstDotIndex + 1);
    var secondLine = data.label1.substring(firstDotIndex + 1).trim();
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      id: "sell-car-hero-title-line-1",
      className: "block mb-4"
    }, firstLine), /*#__PURE__*/React.createElement("span", {
      id: "sell-car-hero-title-line-2"
    }, secondLine));
  }()), data.label2 && /*#__PURE__*/React.createElement("p", {
    id: "sell-car-hero-subtitle",
    className: "text-[16px] md:text-2xl font-semibold text-gray-700 mt-4 mb-6 md:mb-10 max-w-[500px] leading-7"
  }, data.label2), /*#__PURE__*/React.createElement("button", {
    id: "sell-car-hero-cta-button",
    onClick: handleCTAClick,
    className: "cursor-pointer bg-primary-new outline-none border-none text-white font-bold text-base md:text-[18px] px-8 md:px-12 py-3 md:py-4 rounded-xl  transition-all duration-300 transform hover:scale-105"
  }, data.cta.text)))));
};
export default SellCarHero;